import React, {FC, useState} from "react";
import InputField from "../../input-field";
import Button from "../../button";
import useSubmitTrainingMaterialsRequest, {
  TrainingMaterialsRequest
} from "../../../hooks/use-submit-training-materials-request";

const BookstoreTrainingRequest: FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const submit = useSubmitTrainingMaterialsRequest((data) => {
    if (data?.submitTrainingMaterialsRequest) {
      const { statusCode, message } = data.submitTrainingMaterialsRequest;
      if (statusCode === 200) {
        setEmail("");
        setMessage("");
        setSuccessMessage(message);
        setSubmitting(false);
      } else {
        setErrorMessage(message);
        setSubmitting(false);
      }
    }
  })

  return <>
    <h2>Training Materials Request</h2>
    <p>If you did not find the training content you were looking for, please describe that content here and submit your
      request.</p>
    <InputField id="email"
                label="Email:"
                type="text"
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}/>
    <InputField id="message"
                label="Message:"
                type="text"
                multiline={true}
                defaultValue={message}
                onChange={(e) => setMessage(e.target.value)}/>
    {email && message &&
      <>
        {
          submitting
            ? <p>Submitting...</p>
            : <Button text="Submit" onClick={() => {
              setSuccessMessage("");
              setErrorMessage("");
              setSubmitting(true);
              const request: TrainingMaterialsRequest = { email, message };
              submit(request);
            }}/>
        }
      </>
    }
    {successMessage &&
      <p>{successMessage}</p>
    }
    {errorMessage &&
      <p style={{ color: "red" }}>{errorMessage}</p>
    }
  </>
}

export default BookstoreTrainingRequest;
